import { CalendarPage, DayDisplayPage } from "../../pages/calendar";

export const routeCalendar = "/calendar";
export const routeCalendarByAsset = "/calendar/:assetName";
export const routeDayDisplay = "/day-display";

export const calendarRoutes = [
	{
		path: routeCalendar,
		element: <CalendarPage />,
	},
	{
		path: routeCalendarByAsset,
		element: <CalendarPage />,
	},
	{
		path: routeDayDisplay,
		element: <DayDisplayPage />,
	},
];
